module.exports = __webpack_public_path__ + "noResults.c92a18abaea78b2981bce69e1646d016.hashedasset.svg";